import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TraumatologoVeterinarioAlmeria() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            <strong>Traumatólogo Veterinario Almería</strong> - TPLO y Fracturas
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl leading-relaxed mb-8">
            <strong>Especialista en traumatología veterinaria en Almería</strong> con más de 25 años de experiencia. Cirugía TPLO, fracturas, luxaciones y ortopedia avanzada en tu clínica.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="https://wa.me/34600581975"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center space-x-2 bg-green-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp 24h</span>
            </a>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                <strong>Traumatología Veterinaria</strong> Especializada en Almería
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Como <strong>traumatólogo veterinario en Almería</strong>, me especializo en el tratamiento quirúrgico de lesiones ortopédicas complejas: <strong>cirugía TPLO, fracturas, luxaciones, displasias</strong> y deformidades angulares.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Mi servicio móvil de <strong>traumatología veterinaria</strong> permite realizar estas cirugías especializadas directamente en tu clínica de <strong>Almería, Roquetas de Mar, El Ejido</strong> o cualquier localidad de la provincia.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Con más de <strong>25 años de experiencia</strong> como <strong>especialista en traumatología veterinaria</strong>, he realizado miles de cirugías ortopédicas con excelentes resultados de recuperación.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/e33b3da63be1e3bde67f6aa19076dce9.jpg"
                alt="Traumatólogo veterinario Almería realizando cirugía TPLO especializada en perros"
                title="Traumatología veterinaria Almería - Cirugía TPLO y fracturas"
                className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* TPLO Section */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Cirugía TPLO</strong> en Almería
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Especialista en <strong>TPLO (Osteotomía de Nivelación de la Meseta Tibial)</strong> para rotura de ligamento cruzado
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Veterinary%20TPLO%20surgery%20procedure%20showing%20tibial%20plateau%20leveling%20osteotomy%20technique%20with%20bone%20plates%20and%20screws%2C%20detailed%20orthopedic%20surgery%20for%20cruciate%20ligament%20repair%20in%20dogs%2C%20professional%20veterinary%20surgical%20procedure%20with%20specialized%20equipment&width=600&height=500&seq=tplo-surgery-almeria-02&orientation=landscape"
                alt="Cirugía TPLO Almería - Tratamiento ligamento cruzado en perros con técnica especializada"
                title="TPLO Almería - Osteotomía de Nivelación de Meseta Tibial"
                className="w-full h-[400px] object-cover object-top rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                ¿Qué es la <strong>Cirugía TPLO</strong>?
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                La <strong>TPLO</strong> es la técnica quirúrgica más avanzada para tratar la rotura del ligamento cruzado craneal en perros. Como <strong>traumatólogo veterinario especializado en TPLO en Almería</strong>, realizo esta cirugía con precisión milimétrica.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Esta técnica modifica la biomecánica de la rodilla, eliminando la necesidad del ligamento cruzado y proporcionando una recuperación funcional excelente.
              </p>
              <div className="bg-teal-50 rounded-lg p-6 border-l-4 border-teal-500">
                <h4 className="font-bold text-gray-900 mb-2">Ventajas de la TPLO:</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Recuperación funcional superior al 95%</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Menor riesgo de artrosis</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Retorno completo a la actividad</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Técnica gold standard en traumatología veterinaria</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Servicios de Traumatología Veterinaria</strong> en Almería
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía TPLO</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Tratamiento de rotura de ligamento cruzado con técnica TPLO en <strong>Almería</strong>
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-bone-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Fracturas</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Osteosíntesis con placas, clavos y fijadores externos para todo tipo de fracturas
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-pulse-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Luxación de Rótula</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Corrección quirúrgica de luxación patelar medial y lateral
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-contrast-drop-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Displasia de Cadera</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Osteotomía triple pélvica y otras técnicas para displasia
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scissors-cut-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Deformidades Angulares</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Corrección de deformidades óseas congénitas o adquiridas
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Artroscopia</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Cirugía mínimamente invasiva para diagnóstico y tratamiento articular
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Por Qué Elegir un <strong>Traumatólogo Veterinario Especializado</strong>?
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Experiencia Especializada</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Más de 25 años dedicados exclusivamente a <strong>traumatología veterinaria</strong> y cirugía ortopédica
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-tools-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Equipamiento Avanzado</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Instrumental especializado de última generación para cirugía ortopédica en <strong>Almería</strong>
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-add-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Resultados Excelentes</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Más del 95% de recuperación funcional completa en cirugías TPLO y fracturas
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Tu Paciente Necesita un <strong>Traumatólogo Veterinario</strong>?
          </h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed">
            Contacta conmigo para valoración de casos de <strong>TPLO, fracturas o luxaciones</strong> en <strong>Almería</strong>. Servicio móvil en tu clínica.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="tel:+34600581975"
              className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}